import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'startOn'
})
export class StartOnPipe implements PipeTransform {
    transform(input: any, start: any, hasPagination?: boolean): any[] {
        if (!input)
            return input;

        if (hasPagination) {
            start = +start; // Parse to int
            return input.slice(start);
        }
        else
            return input;
    }
}
